import { css } from '@firebolt-dev/css'
import { useEffect, useState } from 'react'
import { HexColorPicker } from 'react-colorful'

export function UIEditorFieldColor({ value, onChange }) {
  const [localValue, setLocalValue] = useState(value)
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (localValue !== value) setLocalValue(value)
  }, [value])
  return (
    <label
      tabIndex={0}
      className='fieldcol'
      css={css`
        flex: 1;
        position: relative;
        .fieldcol-control {
          display: flex;
          align-items: center;
          background: var(--bg4);
          border-radius: 5px;
          padding: 3px;
          height: 34px;
          /* &:hover {
            cursor: pointer;
          } */
        }
        .fieldcol-swatch {
          width: 28px;
          height: 28px;
          border-radius: 7px;
          /* background: #32323b; */
          padding: 3px;
          margin: 0 8px 0 0;
          display: flex;
        }
        .fieldcol-swatchcolor {
          flex: 1;
          border-radius: 4px;
        }
        input {
          flex: 1;
          width: 100%;
          /* text-align: right; */
          /* cursor: inherit; */
          &::selection {
            background-color: white;
            color: rgba(0, 0, 0, 0.8);
          }
        }
        .fieldcol-picker {
          position: absolute;
          bottom: calc(100% + 8px);
          left: 0;
        }
      `}
      onFocus={() => {
        console.log('onFocus')
        setOpen(true)
      }}
      onBlur={e => {
        console.log('onBlur')
        setOpen(false)
        onChange(localValue)
      }}
    >
      <div className='fieldcol-control'>
        <div className='fieldcol-swatch'>
          <div
            className='fieldcol-swatchcolor'
            css={css`
              background: ${localValue};
            `}
          />
        </div>
        <input
          type='text'
          value={localValue || ''}
          // onFocus={e => e.target.select()}
          onChange={e => setLocalValue(e.target.value)}
          onKeyDown={e => {
            if (e.code === 'Enter') {
              e.preventDefault()
              onChange(localValue)
              e.target.blur()
            }
          }}
        />
      </div>
      {open && (
        <div className='fieldcol-picker'>
          <HexColorPicker color={localValue} onChange={setLocalValue} />
        </div>
      )}
    </label>
  )
}
